import { useEffect, useMemo, useRef, useState } from 'react';
import { getFeeds } from '../../api/feeds';
import { useDispatch } from 'react-redux';
import { clearCurrentUser } from '../../store/auth/authSlice';
import { Feed, UserEvents } from './types';
import { fetchNextEvents } from '../../api/users';

export const useHome = () => {
    const [feedsLoading, setFeedsLoading] = useState(false);
    const [feeds, setFeeds] = useState<Feed[]>([]);
    const [feedsError, setFeedsError] = useState(null);
    const [userEventsLoading, setUserEventsLoading] = useState(false);
    const [userEvents, setUserEvents] = useState<UserEvents>({
        nextEvents: [],
        awaitingVoteEvents: [],
    });
    const [userEventsError, setUserEventsError] = useState(null);
    const [error, setError] = useState(null);
    const [takeFeeds, setTakeFeeds] = useState(30);
    const dispatch = useDispatch();

    const initialized = useRef(false);

    async function fetchFeeds(take?: number) {
        setFeedsLoading(true);
        try {
            const { data } = await getFeeds(take || 30);
            setFeeds(data);
        } catch (error: any) {
            if (error.response.status === 401) {
                dispatch(clearCurrentUser());
            }
            console.warn(error);
            setFeedsError(error);
        }
        setFeedsLoading(false);
    }

    async function fetchUserEvents() {
        setUserEventsLoading(true);
        try {
            const data = await fetchNextEvents();
            setUserEvents(data);
        } catch (error: any) {
            if (error.response.status === 401) {
                dispatch(clearCurrentUser());
            }
            console.warn(error);
            setUserEventsError(error);
        }
        setUserEventsLoading(false);
    }

    useEffect(() => {
        async function fetchData() {
            try {
                fetchFeeds();
                fetchUserEvents();
            } catch (error: any) {
                if (error.response.status === 401) {
                    dispatch(clearCurrentUser());
                }
                console.warn(error);
                setError(error);
            }
        }

        if (!initialized.current) {
            initialized.current = true;
            fetchData();
        }
    }, [dispatch]);

    const showLoadMoreFeedsButton = useMemo(
        () => feeds?.length === takeFeeds,
        [feeds, takeFeeds]
    );

    const onShowMoreFeedsClick = async () => {
        const newTake = takeFeeds + 30;
        setTakeFeeds(newTake);
        fetchFeeds(newTake);
    };

    return {
        feedsLoading,
        feeds,
        feedsError,
        onShowMoreFeedsClick,
        showLoadMoreFeedsButton,
        userEventsLoading,
        userEvents,
        userEventsError,
        error,
    };
};
